import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { get } from "lodash";
import MOMDesc from "../MOM/MOMDesc";
import {
  getTimeOfTheGivenDate,
  dateFormat,
  isValidArray,
  getColor
} from "../../helper";
import { Link } from "react-router-dom";
import { PATHS } from "../../constant";
import MOMDecisions from "../MOM/MOMDecisions";

const MeetingDecisions = ({
  momDesc,
  meetingDecisionDTOS,
  permission,
  dataObj
}) => {
  return (
    <React.Fragment>
      <Container fluid className="momDesc">
        <Row>
          {(get(meetingDecisionDTOS, "meetingId") && (
            <div className="momDesc-info">
              <div className="agenda-number-desc">
                AGENDA{" "}
                {console.log(
                  get(permission, "readAgenda"),
                  get(meetingDecisionDTOS, "meetingDTO.clickable")
                )}
                {get(meetingDecisionDTOS, "meetingDTO.clickable") ? (
                  <Link
                    to={{
                      pathname: PATHS.AGENDA_DETAILS,
                      search: `?agendaId=${get(
                        meetingDecisionDTOS,
                        "meetingId",
                        "NA"
                      )}`,
                      state: {
                        agendaId: get(meetingDecisionDTOS, "meetingId")
                      }
                    }}
                  >
                    #{get(meetingDecisionDTOS, "meetingId", null)}
                  </Link>
                ) : (
                  <span>#{get(meetingDecisionDTOS, "meetingId")}</span>
                )}
              </div>
              <h3>
                {get(meetingDecisionDTOS, "meetingDTO.meetingName", null)}
              </h3>

              <div className="mom-desc">
                <div className="d-flex flex-row justify-content-between align-items-center">
                  <div className="meeting-info meeting-when">
                    <span>
                      <b>When</b>
                      {dateFormat(
                        get(meetingDecisionDTOS, "meetingDTO.meetingDate", null)
                      )}
                      {", "}
                      {getTimeOfTheGivenDate(
                        get(meetingDecisionDTOS, "meetingDTO.time", null)
                      )}
                    </span>
                  </div>
                  <div
                    className={`${getColor(
                      get(meetingDecisionDTOS, "issueStatus", "").toLowerCase()
                    )} decision-status-container unClickable`}
                  >
                    <p>{get(meetingDecisionDTOS, "issueStatus", "NA")}</p>
                  </div>
                </div>
              </div>

              {/* <div className="meeting-info meeting-venue">
              <span>
                <b>Venue</b>
                {get(meetingDecisionDTOS, "meetingDTO.venue", null)}
              </span>
            </div> */}

              {/* <div className="meeting-info meeting-attended">
              <span>
                <b>Attended</b>
                {get(meetingDecisionDTOS, "meetingDTO.attended", null)}
              </span>
            </div> */}
            </div>
          )) ||
            null}

          {momDesc ? (
            //  <Col lg={12}>
            // <MOMDesc
            // readMore="true"
            // meeting={meetingDecisionDTOS}
            // count={meetingDecisionDTOS ? meetingDecisionDTOS.length : 0}
            // />
            <MOMDecisions
              readMore="true"
              meeting={meetingDecisionDTOS}
              count={meetingDecisionDTOS ? meetingDecisionDTOS.length : 0}
              dataObj={dataObj}
            />
          ) : (
            //</Col>
            ""
          )}

          {/* {isValidArray(get(meetingDecisionDTOS, "fileDTOList")) &&
            get(meetingDecisionDTOS, "meetingDTO") ? (
            <Col lg={12} className="meeting-attachments">
              <span className="title">Attachment(s) - </span>
              {get(meetingDecisionDTOS, "fileDTOList", []).map(
                (val, index) => {
                  return (
                    <a
                      href={val.s3Url}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {val.title}
                      {index <
                        get(meetingDecisionDTOS, "fileDTOList", []).length - 1
                        ? ", "
                        : ""}{" "}
                    </a>
                  );
                }
              )}
            </Col>
          ) : null
          } */}
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default MeetingDecisions;
